/** Parse API aura score; 0 is a valid value (not missing). */
export function parseAuraScore(raw) {
  if (raw === 0 || raw === '0' || raw === '0.00') {
    return 0;
  }
  if (raw == null || raw === '') {
    return null;
  }
  const n = typeof raw === 'number' ? raw : Number.parseFloat(String(raw));
  return Number.isFinite(n) ? n : null;
}

/** Display aura on wallet/Aura UI — show 0 when score is zero, em dash only when unknown. */
export function formatAuraScoreDisplay(raw) {
  const n = parseAuraScore(raw);
  return n === null ? '—' : String(Math.round(n));
}
